export const DEFAULT_PLACE = [
  {
    regionName: "hanoi",
    placeName: "Ga Hà Nội",
    description: "120 Đ. Lê Duẩn, Văn Miếu, Hoàn Kiếm, Hà Nội, Việt Nam",
    lat: 21.0243303,
    lng: 105.8410933,
    place_id: "ChIJrwU5-56rNTERCecYnwnKphs",
  },
  {
    regionName: "hanoi",
    placeName: "Bến xe Giáp Bát",
    description: "Đ. Giải Phóng, Giáp Bát, Hoàng Mai, Hà Nội, Việt Nam",
    lat: 20.9806483,
    lng: 105.8419952,
    place_id: "ChIJSVRp-o2tNTERnDeQ4cYp09o",
  },
];

export const EVehicleType = {
  CAR4: "CAR4",
  CAR7: "CAR7",
};

export const listVehicle = {
  [EVehicleType.CAR4]: {
    seatCount: 4,
  },
  [EVehicleType.CAR7]: {
    seatCount: 7,
  },
};

export const EStatusTrip = {
  IN_PROGRESS: "IN_PROGRESS",
  ACCEPTED: "ACCEPTED",
  ON_TRIP: "ON_TRIP",
  CANCELED: "CANCELED",
  COMPLETED: "COMPLETED",
  REJECTED: "REJECTED",
  PENDING: "PENDING",
};

export const endPointLocationDrivers = [
  EStatusTrip.IN_PROGRESS,
  EStatusTrip.ARRIVED,
];

export const canceledTripStatus = [EStatusTrip.CANCELED];

export const labelsStatusTrip = {
  [EStatusTrip.IN_PROGRESS]: "Đang tìm tài xế",
  [EStatusTrip.ACCEPTED]: "Tài xế đang đến điểm đón",
  [EStatusTrip.ON_TRIP]: "Đang di chuyển",
  [EStatusTrip.CANCELED]: "Chuyến đi đã bị hủy",
  [EStatusTrip.COMPLETED]: "Chuyến đi đã hoàn thành",
  [EStatusTrip.REJECTED]: "Chuyến đi đã bị hủy",
};
